import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {CSVFileInput} from "../../CSVFileInput";
import {COLUMN_CLIENT_NAME, COLUMNS, DATA_BY_COLUMN} from "./columns";
import {ColumnMappingConfiguration} from "./ColumnMappingConfiguration";
import {FaIcon} from "../../FaIcon";
import {DateFormatSelect} from "../../elements/DateFormatSelect";
import {CurrencySelect} from "../../elements/CurrencySelect";
import {TimezoneSelect} from "../../selects/TimezoneSelect";
import {HELP_SHEET, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';
import {
    CLICKS_METRIC_NAME,
    CONVERSIONS_METRIC_NAME,
    COST_METRIC_NAME, IMPRESSIONS_METRIC_NAME,
    PROPERTIES_FOR_METRIC, PURCHASES_VALUE_METRIC_NAME
} from "../../dashboard/metrics";


class AddAdAccountFormComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
            accountName: null,
            accountId: null,
            csvUrl: null,
            dateFormat: null,
            currency: null,
            csvHeaders: null,
            timezone: null,
            columnMappings: COLUMNS.map(column => ({column: column, header: null})),
            clientNameFilter: null
        };

        this.handleColumnMappingChange = this.handleColumnMappingChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCSVFileChange = this.handleCSVFileChange.bind(this);
        this.handleDateFormatChange = this.handleDateFormatChange.bind(this);
        this.handleClientNameFilterChange = this.handleClientNameFilterChange.bind(this);
        this.handleTimezoneChange = this.handleTimezoneChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleAccountNameChange = this.handleAccountNameChange.bind(this);
        this.handleAccountIdChange = this.handleAccountIdChange.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    handleClientNameFilterChange(event) {
        this.setState({
            clientNameFilter: event.target.value
        });
    }

    handleAccountNameChange(event) {
        this.setState({
            accountName: event.target.value
        });
    }

    handleAccountIdChange(event) {
        this.setState({
            accountId: event.target.value
        });
    }

    getColumnMappingForPost() {
        //  Devuelve un JSON del tipo {"column_enum": header_value, ...}
        if(this.state.columnMappings === null)
            return null;

        const columnsMapping = {};
        this.state.columnMappings.forEach((columnMapping) => {
            columnsMapping[columnMapping["column"]] = columnMapping["header"];
        });
        return columnsMapping;
    }

    getFiltersForPost() {
        //  Devuelve un JSON tipo
        /*
            {
                "filterType": "AND",
                "conditions": [
                    {
                        "column": "CLIENT_NAME",
                        "operator": "equals",
                        "value": "Paruolo"
                    }
                ]
            }
        * */
        const conditions = this.state.clientNameFilter !== null ? [{
            "column": "CLIENT_NAME",
            "operator": "equals",
            "value": this.state.clientNameFilter
        }] : [];

        return {
            "filterType": "AND",
            "conditions": conditions
        };
    }

    handleDateFormatChange(newFormatValue) {
        this.setState({
            dateFormat: newFormatValue
        });
    }

    handleTimezoneChange(newTimezone) {
        this.setState({
            timezone: newTimezone
        });
    }

    handleCurrencyChange(event) {
        this.setState({
            currency: event.target.value
        });
    }

    hasDuplicatedHeaders() {
        if(this.state.columnMappings === null)
            return false;
    
        const headerUsed = [];
        let hasDuplication = false;
        this.state.columnMappings.forEach((columnMapping) => {
            if(columnMapping["header"] !== null) {
                if(headerUsed.includes(columnMapping["header"])) {
                    hasDuplication = true;
                } else {
                    headerUsed.push(columnMapping["header"]);
                }
            }
        });
        return hasDuplication;
    }

    handleSubmit(event) {
        event.preventDefault();

        if(this.hasDuplicatedHeaders())
        {
            alert("Hay columnas de la planilla que se mapearon más de una vez. Debe corregirse para continuar.");
            return;
        }

        this.setState({
            isSaving: true
        });

        new APIClient(this.submitUrl()).call('POST', {
            'url': this.state.csvUrl,
            'columns_mapping': this.getColumnMappingForPost(),
            'filters': this.getFiltersForPost(),
            'name': this.state.accountName,
            'date_format': this.state.dateFormat,
            'currency': this.state.currency,
            'timezone': this.state.timezone,
            'account_id': this.state.accountId
        }).then((data) => {
            this.setState({
                isSaving: false
            });

            if (data.status !== 'OK') {
                if(data.status === 'METRIC_DATA_NOT_VALID') {
                    const metricName =  PROPERTIES_FOR_METRIC[this.getMetricNameFromColumnMetricName(data.error_message)]["Spanish"];
                    alert('Se han detectado valores inválido en la columna de la métrica '+metricName+'.\n\nVerifique los datos. Los valores númericos no pueden contener letras.\n\n\nRecuerde que al editar un Google Sheet, puede demorar unos minutos en actualizar su CSV online.');
                } else {
                    alert(data.error_message);
                }
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit(data.data)
            }
        });
    }

    getMetricNameFromColumnMetricName(columnMetricName) {
        if(columnMetricName === "COST")
            return COST_METRIC_NAME;

        if(columnMetricName === "CLICKS")
            return CLICKS_METRIC_NAME;

        if(columnMetricName === "CONVERSIONS")
            return CONVERSIONS_METRIC_NAME;

        if(columnMetricName === "IMPRESSIONS")
            return IMPRESSIONS_METRIC_NAME;

        if(columnMetricName === "PURCHASE_VALUE")
            return PURCHASES_VALUE_METRIC_NAME;

        return columnMetricName
    };

    isCSVFileImported() {
        return this.state.csvUrl !== null;
    }

    footerButton() {
        if (this.state.isSaving) {
            return <Spinner color="positive small"/>
        } else {
            return <input type="submit" value="Agregar" className="btn -submit"/>
        }
    }

    handleCSVFileChange(url, headers, columnsMapping, currency, timezone, dateFormat) {
        const newState = {};
        newState.csvUrl = url;
        newState.csvHeaders = headers;


        newState.currency = (currency !== null) ? currency : this.state.currency;
        newState.dateFormat = (dateFormat !== null) ? dateFormat : this.state.dateFormat;
        newState.timezone = (timezone !== null) ? timezone : this.state.timezone;

        if (columnsMapping !== null) {
            const newColumnMapping = [];
            this.state.columnMappings.forEach((columnMapping) => {
                newColumnMapping.push({
                    column: columnMapping.column,
                    header: (columnsMapping[columnMapping.column] !== undefined) ? columnsMapping[columnMapping.column] : columnMapping.header
                })
            });

            newState.columnMappings = newColumnMapping;
        }

        this.setState({...newState});
    }

    handleColumnMappingChange(order, newColumn, newHeader) {
        const columnMapping = this.state.columnMappings;
        columnMapping[order - 1] = {
            column: newColumn,
            header: newHeader
        };

        this.setState({
            columnMappings: columnMapping
        });
    }

    renderColumnMappingInputs() {
        let order = 0;
        const inputs = [];
        this.state.columnMappings.forEach(columnMapping => {
            order += 1;
            inputs.push(<ColumnMappingConfiguration
                order={order}
                column={columnMapping.column}
                header={columnMapping.header}
                headersOptions={this.state.csvHeaders}
                onValueChange={this.handleColumnMappingChange}
            />);
        });
        return inputs;
    }

    getClientNameFiltered() {
        if (this.state.clientNameFilter === null)
            return;
        return this.state.clientNameFilter;
    }

    isClientColumnInCSV() {
        return this.state.columnMappings.some((columnMapping) => (columnMapping.column === COLUMN_CLIENT_NAME && columnMapping.header !== null));
    }

    render() {
        const { t } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <div className="col-12 p-0 m-0">
                                <label>URL del archivo CSV<LinkToArticle article={HELP_SHEET}  /></label>
                                <CSVFileInput onImport={this.handleCSVFileChange}/>
                            </div>
                        </div>
                        <div className="form-group" id="account_identifiers">
                            <label className="separator">{t('sheet_account.account_data')}</label>
                            <div className="form-row">
                                <div className="form-col">
                                    <label>Nombre</label>
                                    <input name="account_name" id="account_name" type="text"
                                           value={this.state.accountName}
                                           onChange={this.handleAccountNameChange}
                                           readOnly={!this.isCSVFileImported()}
                                           className="form-control"
                                           required="required"
                                    />
                                </div>
                                <div className="form-col">
                                    <label>Identificador único numérico</label>
                                    <input name="account_id" type="number"
                                           value={this.state.accountId}
                                           onChange={this.handleAccountIdChange}
                                           readOnly={!this.isCSVFileImported()}
                                           className="form-control"
                                           placeholder={t('sheet_account.auto_generate_placeholder')}/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-col">
                                    <label>Formato de fecha</label>
                                    <DateFormatSelect selected={this.state.dateFormat}
                                                      readOnly={!this.isCSVFileImported()}
                                                      onChange={this.handleDateFormatChange}
                                                      required="required"
                                    />
                                </div>
                                <div className="form-col">
                                    <label>Moneda</label>
                                    <CurrencySelect selected={this.state.currency}
                                                    readOnly={!this.isCSVFileImported()}
                                                    onChange={this.handleCurrencyChange}
                                                    required="required"
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-col p-0">
                                    <label>Huso horario</label>
                                    <TimezoneSelect selectedOption={this.state.timezone}
                                                    readOnly={!this.isCSVFileImported()}
                                                    onTimezoneChange={this.handleTimezoneChange}
                                                    required="required"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group" id="daily_limit_group">
                            <label className="separator">{t('sheet_account.column_mapping')}</label>
                            {this.renderColumnMappingInputs()}
                        </div>
                        <div className="form-group" id="account_identifiers">
                            <label className="separator">{t('sheet_account.filter_rows')}</label>
                            <div className="form-row">
                                <div className="col">
                                    <input name="column" readOnly={true}
                                           value={DATA_BY_COLUMN[COLUMN_CLIENT_NAME].Spanish} type="text"
                                           className={"form-control"}/>
                                </div>
                                <div className="col-auto pt-2">
                                    <FaIcon iconName="equals" style={{color: "#4A4A4A"}}/>
                                </div>
                                <div className="col">
                                    <input name="client_name_filter" readOnly={!this.isClientColumnInCSV()}
                                           required={this.isClientColumnInCSV()}
                                           placeholder={"Sólo si la columna Cliente está presente"}
                                           value={this.getClientNameFiltered()} type="text"
                                           onChange={this.handleClientNameFilterChange}
                                           className={"form-control"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }

    submitUrl() {
        return API_URL + 'agency/sheet-ad-account/';
    }
}

export const AddAdAccountForm = withTranslation()(AddAdAccountFormComponent);
